enum TaxiOfficerAddViewMode {
  TAXI = "TAXI",
  RAILY = "RAILY",
}

export default TaxiOfficerAddViewMode;
